import axios from "axios";

// ENV: PROD
const baseURL = "https://1v16btuuia.execute-api.ap-southeast-1.amazonaws.com/PROD";
// ENV: LOCAL
// const baseURL = "http://127.0.0.1:5000";

const api = axios.create({
  baseURL,
  timeout: 15 * 1000,
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
